export default function splitAtWhitespace(value: string | null): string[] {
	if (value === null) {
		return [];
	}
	const r = value.match(/\S+/g);
	return r !== null ? r : [];
}
